import { render, staticRenderFns } from "./MobileSearch.vue?vue&type=template&id=20d5a020&scoped=true"
import script from "./MobileSearch.vue?vue&type=script&lang=js"
export * from "./MobileSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d5a020",
  null
  
)

export default component.exports